import React from "react";
import { Button, Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import notfound from "../../assets/images/404-error.png";
const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container
      className="d-flex flex-column justify-content-center align-items-center text-center"
      style={{ minHeight: "100vh", padding: "2rem" }}
    >
      <img
        src={notfound}
        alt="404 Not Found"
        style={{ maxWidth: "250px", width: "100%" }}
      />

      <p className="text-muted mt-4">
        Oops! The page you are looking is not found.....
      </p>
      <Button color="success" onClick={() => navigate("/")}>
        Go to Home
      </Button>
    </Container>
  );
};

export default NotFound;
